import { render, staticRenderFns } from "./SkyRedeemStep.vue?vue&type=template&id=3271405b"
import script from "./SkyRedeemStep.vue?vue&type=script&lang=js"
export * from "./SkyRedeemStep.vue?vue&type=script&lang=js"
import style0 from "./SkyRedeemStep.vue?vue&type=style&index=0&id=3271405b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports